import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

function ReportHeader({name}) {
    const navigate = useNavigate();

    const navigateBack = () => {
        navigate(-1);
    };
    return (
        <div style={{
            position: 'absolute',
            top: '60px',
            left: 0,
            right: 0,
        }}>
            <div
                className="custom-navbar d-flex justify-content-between align-items-center"
                style={{
                    padding: '15px',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1000, // Garante que fique acima de outros elementos
                    backgroundColor: 'white', // Evita transparência se tiver fundo branco
                    borderBottom: '1px solid #ccc' // opcional: borda inferior para destacar
                }}
            >
                <div onClick={navigateBack}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div
                    className="mx-auto"
                    style={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)'
                    }}
                >
                    {name}
                </div>
            </div>
        </div>

    );
}

export default ReportHeader;